<template>
  <!-- 公共的banner -->
  <div class="cmp-banner-wrap" :class="{'mobile': _isMobile}">
    <div class="cmp-banner">
      <img :src="bannerObj[bannerType]" alt="" v-if="!_isMobile">
      <img :src="bannerObjH5[bannerType]" alt="" v-else>
    </div>

    <!-- <div class="g-banner-title">
      <h1>{{titleObj[bannerType]}}</h1> 
    </div> -->

    <!-- 面包屑 -->
    <cmpBread v-if="!$route.meta.hideBread"></cmpBread>
  </div>
</template>

<script>
export default {
  props: {
    bannerType: {
      type: String,
      default: '5'  // 1资讯动态 2参观 3展览 4馆藏精品 5社教 6通知公告 7文化 8视频 9搜索 10关于我们  11通知公告 12文创产品
    },
  },
  data() {
    return {
      // imgUrl: require('@images/banner6.png'),
      bannerObj: {
        // '1': require('@images/1.jpg'),
        '1': require('@images/banner_info.png'),
        '2': require('@images/banner_visit.png'),
        '3': require('@images/banner_exhibition.png'),
        '4': require('@images/banner_collect.png'),
        '5': require('@images/banner_activity.png'),
        '6': require('@images/banner_service.png'),
        '7': require('@images/banner_culture.png'),
        '8': require('@images/banner_video.png'),
        '9': require('@images/banner_search.png'),
        '10': require('@images/banner_about.png'),
        '11': require('@images/banner_notice.png'),
        '12': require('@images/banner_product.png'),
        // '2': require('@images/pic_banner_exhibition@2x.png'),
        // '3': require('@images/banner-collect.jpg'),
        // '4': require('@images/pic_banner_education.png'),
        // '5': require('@images/banner-research.jpg'),
        // '6': require('@images/banner-creative.jpg'),
        // '7': require('@images/banner-about.jpg'),
        // '8': require('@images/banner-identify.jpg'),
        // '9': require('@images/banner-video.jpg'),
        // '10': require('@images/banner-notice.jpg'),
      },
      bannerObjH5: {
        '1': require('@images/banner_info_2.png'),
        '2': require('@images/banner_visit_2.png'),
        '3': require('@images/banner_exhibition_2.png'),
        '4': require('@images/banner_collect_2.png'),
        '5': require('@images/banner_activity_2.png'),
        '6': require('@images/banner_service_2.png'),
        '7': require('@images/banner_culture_2.png'),
        '8': require('@images/banner_video_2.png'),
        '9': require('@images/banner_search_2.png'),
        '10': require('@images/banner_about_2.png'),
        '11': require('@images/banner_notice_2.png'),
        '12': require('@images/banner_product.png'),
      },
      titleObj: {
        '1': '导览',
        '2': '陈列展览',
        '3': '藏品',
        '4': '教育',
        '5': '学术',
        '6': '文创',
        '7': '关于',
        '8': '民间文物鉴定',
        '9': '视频资源',
        '10': '通知公告',
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.cmp-banner {
  // width: 100%;
  // height: 560px;
  img {
    width: 100%;
    height: 360px;
    object-fit: cover;
    object-position: center center;
  }
}
</style>
